import { render, staticRenderFns } from "./finuslugi-23.vue?vue&type=template&id=5277535c&scoped=true&"
import script from "./finuslugi-23.vue?vue&type=script&lang=js&"
export * from "./finuslugi-23.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5277535c",
  null
  
)

export default component.exports